import { t } from '../../common/i18n';
import { ConfirmationDialog } from '../ConfirmationDialog';
import type { JSX } from 'react';

export interface SupportOrServiceConfirmationDialogProps {
  onCancel: () => void;
  onConfirm: (onCloseDialog: () => void) => void;
  icon: JSX.Element;
  header: string;
  body: JSX.Element | string;
}

export const SupportOrServiceConfirmationDialog = ({
  onConfirm,
  onCancel,
  icon,
  header,
  body,
}: SupportOrServiceConfirmationDialogProps): JSX.Element => {
  return (
    <ConfirmationDialog
      onCloseDialog={onCancel}
      onConfirm={onConfirm}
      icon={icon}
      confirmButtonText={t.M03S('Yes')}
      body={body}
      header={header}
    />
  );
};
